export default __webpack_public_path__ + "static/media/OPEN-template.a5397f77.png";